<template>
  <div class="warehouse-label-a4">
    <div class="warehouse-label-a4-page" v-for="(item, index) in printData" :key="index">
      <div class="warehouse-label-a4-grid-number">{{ getGridNumber(item) }}</div>
      <img class="warehouse-label-a4-qr-code" :src="item.url" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    printData: { type: Array }
  },
  mounted() {
    this.getQRcode()
  },
  methods: {
    // 二维码内容与现有库位打印规则保持一致。
    getQRcode() {
      this.printData.forEach((item, index) => {
        this.$QRCode.toDataURL(
          `${item.floor_number}-${item.print_index || index + 1}`,
          { errorCorrectionLevel: 'L', margin: 0, width: 512 },
          (err, url) => {
            if (err) throw err
            item.url = url
            this.$forceUpdate()
          }
        )
      })
    },
    // A4 唛头只显示实际库位编号。
    getGridNumber(item) {
      if (!item.grid_number) return ''
      const gridNumber = String(item.grid_number)
      const separatorIndex = gridNumber.indexOf('】-')
      return separatorIndex === -1 ? gridNumber : gridNumber.slice(separatorIndex + 2)
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouse-label-a4 {
  color: #000;
}

.warehouse-label-a4-page {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
  width: 297mm;
  height: 210mm;

  background: #fff;
  page-break-after: always;
}

.warehouse-label-a4-grid-number {
  margin-bottom: 12mm;
  font-size: 55mm;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.warehouse-label-a4-qr-code {
  width: 75mm;
  height: 75mm;
}

@media print {
  @page {
    margin: 0;
  }

  .warehouse-label-a4-page {
    width: 297mm !important;
    height: 210mm !important;
    page-break-after: always;
  }
}
</style>
